import memoize from 'lru-memoize';
import { createValidator, required } from 'utils/validation';

// @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
const passwordValidation = createValidator({
  password: [required],
  token: [required],
});
export default memoize(10)(passwordValidation);
